import React, { useEffect, useState } from "react";
import { fetchMeetupspagelist } from "../services/Meetupspagelist";
import { API_BASE } from "../api/apiConfig";

const Meetupspagecitydata = () => {
  const [meetups, setMeetups] = useState([]);
  const [filteredMeetups, setFilteredMeetups] = useState([]);

  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("All");
  const [city, setCity] = useState("All");
  const [viewMode, setViewMode] = useState("all"); // all | city
  const [loading, setLoading] = useState(true);

  /* ================= API LOAD ================= */
  useEffect(() => {
    loadMeetups();
  }, []);

  const loadMeetups = async () => {
    try {
      const res = await fetchMeetupspagelist();
      if (res?.status) {
        setMeetups(res.data);
        setFilteredMeetups(res.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  /* ================= FILTER LOGIC ================= */
  useEffect(() => {
    let data = [...meetups];

    if (search) {
      data = data.filter(
        (item) =>
          item.heading.toLowerCase().includes(search.toLowerCase()) ||
          item.city.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (category !== "All") {
      data = data.filter((item) =>
        JSON.parse(item.category).includes(category)
      );
    }

    if (city !== "All") {
      data = data.filter((item) => item.city === city);
    }

    setFilteredMeetups(data);
  }, [search, category, city, meetups]);

  if (loading) {
    return <p className="text-center py-10">Loading meetups...</p>;
  }

  /* ================= GROUP BY CITY ================= */
  const groupedByCity = filteredMeetups.reduce((acc, item) => {
    acc[item.city] = acc[item.city] || [];
    acc[item.city].push(item);
    return acc;
  }, {});

  return (
     <section id="meetups-section" className="py-12 md:py-16">
      <div className="container mx-auto px-4 md:px-6">
        {/* Header with Filters */}
        <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-center md:justify-between reveal-on-scroll revealed">
          <div>
            <h2 className="text-2xl font-bold tracking-tight text-slate-800 md:text-3xl">
              Upcoming <span className="text-gradient">Meetups</span>
            </h2>
            <p className="text-slate-600">
              Find and join travel meetups happening near you
            </p>
          </div>
          {/* Filters */}
          <div className="flex flex-col gap-2 md:flex-row">
            <div className="relative">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path></svg>
              <input value={search} onChange={(e) => setSearch(e.target.value)}
                className="flex h-10 w-full rounded-md border bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 pl-10 border-slate-200"
                placeholder="Search meetups..."
                type="text"
              />
            </div>
            {/* Filter Buttons */}
            <div className="flex gap-2">
              <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 h-10 px-4 py-2 bg-primary text-white hover:bg-primary/90 transition-all duration-300 hover:scale-105" onClick={() => setViewMode("all")}
              className={`px-4 py-2 rounded-lg ${
                viewMode === "all"
                  ? "bg-green-500 text-white"
                  : "border"
              }`}>
                All Meetups
              </button>
              <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 border bg-background hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 border-primary/30 text-primary" onClick={() => setViewMode("city")}
              className={`px-4 py-2 rounded-lg ${
                viewMode === "city"
                  ? "bg-green-500 text-white"
                  : "border"
              }`}>
                By City
              </button>
            </div>
          </div>
        </div>
        {/* Filter Tags */}
        <div className="mb-8 flex flex-wrap gap-2 reveal-on-scroll revealed">
          <div className="flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-1.5 text-sm">
            {/* Filter Icon SVG */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="lucide lucide-filter h-4 w-4 text-primary"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
            </svg>
            <span className="text-slate-600">Filters:</span>
          </div>
          {/* Category Filter */}
         {/* <div className="relative">
            <select className="appearance-none rounded-lg border border-slate-200 bg-white px-3 py-1.5 pr-8 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-primary/30">
              <option value="All">All</option>
              <option value="Adventure">Adventure</option>
              <option value="Cultural">Cultural</option>
              <option value="Food">Food</option>
              <option value="Nature">Nature</option>
              <option value="Photography">Photography</option>
              <option value="Spiritual">Spiritual</option>
              <option value="Community">Community</option>
              <option value="Hiking">Hiking</option>
              <option value="Wellness">Wellness</option>
              <option value="Art">Art</option>
              <option value="Cycling">Cycling</option>
            </select>
            <svg
              className="lucide lucide-chevron-down absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400 pointer-events-none"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </div>*/}
          {/* Location Filter */}
          <div className="relative">
            <select value={city} onChange={(e) => setCity(e.target.value)} className="appearance-none rounded-lg border border-slate-200 bg-white px-3 py-1.5 pr-8 text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-primary/30">
              <option value="All">All</option>
              {[...new Set(meetups.map((m) => m.city))].map((c) => (
                <option key={c} value={c}>
                  {c}
                </option>
              ))}
            </select>
            <svg
              className="lucide lucide-chevron-down absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400 pointer-events-none"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
          </div>
        </div>
        {/* Meetup Cards Grid */}
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
         

     {filteredMeetups.map((item) => (
          <div
            className="text-card-foreground group overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:border-primary/30 hover:shadow-md reveal-on-scroll revealed"
            style={{ transitionDelay: "0ms" }}
          >
            <div className="relative h-48 w-full overflow-hidden">
              <img
                alt={item.city}
                loading="lazy"
                decoding="async"
                data-nimg="fill"
                className="object-cover transition-transform duration-700 group-hover:scale-110"
                style={{
                  position: "absolute",
                  height: "100%",
                  width: "100%",
                  inset: 0
                }}
                src={`${API_BASE}/${item.image}`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/30 transition-opacity duration-300 group-hover:opacity-70" />
              <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 absolute right-3 top-3 bg-primary/90 text-white hover:bg-primary">
                {item.city}
              </div>
              {/*<div className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 absolute left-3 top-3 bg-white/90 text-slate-800 hover:bg-white">
                Adventure
              </div>*/}

        {item.local_experts_details && item.local_experts_details.length > 0 && (
              <div className="absolute bottom-3 left-3 flex items-center gap-2">
                <div
                  className="h-8 w-8 rounded-full border-2 border-white ring-1 ring-primary/20 transition-all duration-300 group-hover:ring-primary/40"
                  style={{
                     backgroundImage: `url(${
                    item.local_experts_details[0].profile_image
                      ? `${API_BASE}/${item.local_experts_details[0].profile_image}`
                      : "/member-3.jpg"
                  })`,
                    backgroundSize: "cover"
                  }}
                />
                <div>
                  <p className="text-xs text-slate-300 transition-colors duration-300 group-hover:text-white">
                    Hosted by
                  </p>
                  <p className="text-sm font-medium text-white"> {item.local_experts_details[0].name}</p>
                </div>
              </div>
          )}

            </div>
            <div className="p-4">
              <h3 className="mb-2 text-lg font-medium text-slate-800 transition-colors duration-300 group-hover:text-primary">
                {item.heading}
              </h3>
              <p className="mb-4 text-sm text-slate-600 line-clamp-2" dangerouslySetInnerHTML={{ __html: item.about }}>
                
              </p>
              <div className="space-y-2 text-sm">
                <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-calendar h-4 w-4 text-primary"
                  >
                    <path d="M8 2v4" />
                    <path d="M16 2v4" />
                    <rect width={18} height={18} x={3} y={4} rx={2} />
                    <path d="M3 10h18" />
                  </svg>
                  <span className="text-slate-600">{item.date}</span>
                </div>
                <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-clock h-4 w-4 text-primary"
                  >
                    <circle cx={12} cy={12} r={10} />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                  <span className="text-slate-600">{item.time}</span>
                </div>
                <div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-map-pin h-4 w-4 text-primary"
                  >
                    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                    <circle cx={12} cy={10} r={3} />
                  </svg>
                  <span className="text-slate-600 truncate">
                    {JSON.parse(item.title)[0]}
                  </span>
                </div>
                {/*<div className="flex items-center gap-2 transition-transform duration-300 group-hover:translate-x-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-users h-4 w-4 text-primary"
                  >
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <circle cx={9} cy={7} r={4} />
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                  </svg>
                  <div className="flex items-center gap-1">
                    <span className="text-slate-800">24</span>
                    <span className="text-slate-600">attending</span>
                    <span className="mx-1 text-slate-400">•</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-heart h-3 w-3 text-primary"
                    >
                      <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                    </svg>
                    <span className="text-slate-600">42</span>
                  </div>
                </div>*/}
              </div>
            </div>
            <div className="flex items-center border-t border-slate-200 bg-slate-50 p-4 transition-all duration-300 hover:bg-primary/5">
              <a className="w-full" href={`/MeetupsDtl/${item.id}`}>
                <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 border hover:text-accent-foreground h-10 px-4 py-2 w-full border-primary/30 bg-transparent text-primary hover:bg-primary/10">
                  View Details
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-arrow-right ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
                  >
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                  </svg>
                </button>
              </a>
            </div>
          </div>
       ))}



        </div>
        {/*<div className="mt-8 text-center reveal-on-scroll revealed">
          <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border bg-background hover:text-accent-foreground h-10 px-4 py-2 border-primary/30 text-primary hover:bg-primary/10">
            Load More Meetups
          </button>
        </div>*/}
      </div>
    </section>
  );
};

export default Meetupspagecitydata;
